import React, { useCallback, useMemo, useState } from "react";
import SmartForm, { Field } from "@insightfulscience/smart-react/SmartForm";
import { useLocale } from "@insightfulscience/smart-react/i18";
import { func, node } from "prop-types";
import Select from "@insightfulscience/atomic-react/Select";
import { compose } from "@insightfulscience/shared-utils/fn";
import { initialState, validateForm } from "./form";
import { useCountries } from "../countries";

const eventToNumber = ({ target }) => +target.value;
const QuoteFormFields = ({ children, action }) => {
	const [t] = useLocale("free-trial-biologics-form");
	const [countries, countryById] = useCountries();

	const [, setCountryID] = useState();

	const handleCountryChange = useMemo(
		() => compose(setCountryID, eventToNumber), // callback
		[setCountryID],
	);

	const setCountry = useCallback(
		(form, chosenCountry) => ({
			...form,
			countryID: +chosenCountry,
			countrySelect: countryById.get(+chosenCountry)?.name,
		}),
		[],
	);

	return (
		<SmartForm {...{ validateForm, action }} initialState={initialState} textRender={t}>
			<Field
				fieldClassName="mb-8"
				name="firstName"
				label={t("FIRST_NAME")}
				required
				maxLength={50}
				data-qa-selector="firstName-field"
			/>

			<Field
				fieldClassName="mb-8"
				name="lastName"
				label={t("LAST_NAME")}
				required
				maxLength={50}
				data-qa-selector="lastName-field"
			/>

			<Field
				fieldClassName="mb-8"
				name="email"
				label={t("EMAIL")}
				required
				maxLength={100}
				data-qa-selector="email-field"
			/>

			<Field
				fieldClassName="mb-8"
				name="organization"
				label={t("ORGANIZATION_NAME")}
				required
				maxLength={50}
				data-qa-selector="company-field"
			/>
			<Field
				fieldClassName="mb-8"
				name="position"
				label={t("POSITION")}
				required
				maxLength={50}
				data-qa-selector="company-field"
			/>
			<Field
				label={t("COUNTRY")}
				name="countryID"
				fieldClassName="mb-8"
				required
				parseEvent={eventToNumber}
				onChange={handleCountryChange}
				data-qa-selector="complete-profile-country-selector"
				Control={Select}
				setState={setCountry}
			>
				<Select.Placeholder>{t("COUNTRY_PLACEHOLDER")}</Select.Placeholder>
				{Select.renderOptions(
					countries,
					({ id }) => id,
					({ name }) => name,
				)}
			</Field>
			{children}
		</SmartForm>
	);
};

QuoteFormFields.propTypes = {
	action: func,
	children: node,
};

export default QuoteFormFields;
